import { render, staticRenderFns } from "./BnPrimClientDetail.vue?vue&type=template&id=111223e5&"
import script from "./BnPrimClientDetail.vue?vue&type=script&lang=js&"
export * from "./BnPrimClientDetail.vue?vue&type=script&lang=js&"
import style0 from "./BnPrimClientDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports